import React, {useMemo} from "react"
import styles from "./DailyAttendanceCalendarView.module.css"
import cx from "classnames"
import {roundTwoDigits} from "helpers"

const SummaryView = ({dailyAttendanceSummaryData}) => {
    const tableData = useMemo(() => {
        const {totalAttendedHours, totalMissedHours, totalMakeUpHours, totalDistEdHours, totalScheduleHours} =
            dailyAttendanceSummaryData ?? {}

        const tableData = [
            {label: "Scheduled Hours", total: totalScheduleHours ?? 0},
            {label: "Attended Hours", total: totalAttendedHours ?? 0},
            {label: "Absent Hours", total: totalMissedHours ?? 0},
            {label: "Makeup Hours", total: totalMakeUpHours ?? 0},
            {label: "Distance Ed Hours", total: totalDistEdHours ?? 0}
        ]

        return tableData
    }, [dailyAttendanceSummaryData])

    return (
        <div className={styles.summaryContainer}>
            <div className={styles.summaryWrap}>
                <div className={styles.summaryTitle}>Summary</div>
                <table className={styles.table}>
                    <thead>
                        <tr className={styles.headerRow}>
                            <th className={styles.th}>Type</th>
                            <th className={styles.th}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((row) => (
                            <tr key={row.label}>
                                <td className={cx(styles.td, styles.rowLabel)}>{row.label}</td>
                                <td className={styles.td}>{roundTwoDigits(row.total)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default SummaryView
